import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { Custodian } from '../../../../models/review/custodian.model';

@Component({
    selector: 'lex-create-custodian',
    templateUrl: './create-custodian.component.html',
    styleUrls: ['./create-custodian.component.scss'],
    standalone: false
})
export class CreateCustodianComponent implements OnInit {

  constructor(private formBuilder: UntypedFormBuilder, private dialogRef: MatDialogRef<CreateCustodianComponent>) { }

  newCustodianForm: UntypedFormGroup;
  newCustodian = {
    isOrganization: false,
    name: '',
    title: '',
    memo: '',
    role: '',
    address: '',
    phone: '',
    fax: '',
    cell: '',
    email: '',
    affiliation: '',
    customField1: ''
  } as Custodian;

  ngOnInit(): void {
    this.newCustodianForm = this.formBuilder.group({
      name: ['', [Validators.required, Validators.maxLength(256)]],
      isOrganization: [ false, Validators.required]
    });
  }

  ok(): void {
    this.newCustodian.isOrganization = this.newCustodianForm.controls['isOrganization'].value;
    this.newCustodian.name = this.newCustodianForm.controls['name'].value;
    this.dialogRef.close(this.newCustodian);
  }
}
